import React from 'react';
import { ToastContainer } from 'react-toastify';
import { useTheme } from '@mui/material/styles';
import 'react-toastify/dist/ReactToastify.css';

const CustomToastContainer = () => {
  const theme = useTheme();

  return (
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme={theme.palette.mode}
      toastStyle={{
        fontFamily: theme.typography.fontFamily,
        fontSize: '14px',
        borderRadius: '8px',
        boxShadow: theme.shadows[8]
      }}
      style={{
        // Custom positioning to avoid conflicts with app bar
        top: '80px'
      }}
    />
  );
};

export default CustomToastContainer;
